import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router';
import { pb } from '../lib/pocketbase';
import { queryClient } from '../main';

export type LoginData = {
  email: string;
  password: string;
};

export function useAuth() {
  const navigate = useNavigate();

  const login = useMutation({
    mutationFn: async (data: LoginData) => {
      const emailLowerCase = data.email.toLowerCase();
      return await pb
        .collection('users')
        .authWithPassword(emailLowerCase, data.password);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['user'] });
      navigate('/dashboard');
    },
  });

  const loginWithGoogle = useMutation({
    mutationFn: async () => {
      return await pb.collection('users').authWithOAuth2({
        provider: 'google',
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['user'] });
      navigate('/dashboard');
    },
  });

  const logout = useMutation({
    mutationFn: async () => {
      return await pb.authStore.clear();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['user'] });
      navigate('/login');
    },
  });

  return {
    login,
    loginWithGoogle,
    logout,
    user: pb.authStore.record,
    isAuthenticated: pb.authStore.isValid,
  };
}

export function useAuthProtected<T>(queryFn: () => Promise<T>) {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  if (!isAuthenticated) {
    navigate('/login');
  }
  return queryFn;
}
